if (process.browser) {
    document.addEventListener("DOMContentLoaded", function () {
        function getScript(scriptUrl, callback) {
            const script = document.createElement('script');
            script.src = scriptUrl;
            script.onload = callback;

            document.body.appendChild(script);
        }
        getScript('https://ic7.co/clientes/00085/00003e.js');
        document.querySelector('.site-header .clima .extra-holder').innerHTML = `<div class="weather-widget"> </div>`
    })
}